// Donor-scope peer-fundraising-pages API helpers — CHG-1521 wave 3.
//
// Backend: my_giving_peer_pages.py canonical at /api/v1/my-giving/peer-pages/*.
// 7 endpoints exposed (CHG-0102): list / create / get / patch / delete /
// pause / resume. Wave 3 FE consumes list + pause + resume; create + edit
// + delete wait for a wave 4 CHG with a dedicated detail/edit page.

import { apiClient } from "./client";

export interface MyPeerPage {
  currency?: string | null;
  raised_by_currency?: Record<string, number> | null;
  id: string;
  organization_id: string;
  organization_name: string;
  organization_slug: string | null;
  campaign_id: string;
  campaign_name: string | null;
  fundraiser_donor_id: string | null;
  title: string;
  slug: string;
  story: string | null;
  goal_amount_minor_units: number;
  raised_minor_units: number;
  donor_count: number;
  cover_image_url: string | null;
  status: string;
  share_message: string | null;
  created_at: string;
  updated_at: string;
}

export interface MyPeerPagesEnvelope {
  data: MyPeerPage[];
  pagination: {
    page: number;
    per_page: number;
    total: number;
    total_pages: number;
  };
}

export interface ListMyPeerPagesParams {
  page?: number;
  pageSize?: number;
  sortField?: string;
  sortDirection?: "asc" | "desc";
  search?: string;
}

export async function listMyPeerPages(
  params: ListMyPeerPagesParams = {},
): Promise<{ items: MyPeerPage[]; total: number }> {
  const r = await apiClient().get<MyPeerPagesEnvelope>("/my-giving/peer-pages", {
    params: {
      page: (params.page ?? 0) + 1,
      per_page: params.pageSize ?? 25,
    },
  });
  return { items: r.data.data, total: r.data.pagination.total };
}

export async function pauseMyPeerPage(pageId: string): Promise<MyPeerPage> {
  const r = await apiClient().post<MyPeerPage>(
    `/my-giving/peer-pages/${pageId}/pause`,
  );
  return r.data;
}

export async function resumeMyPeerPage(pageId: string): Promise<MyPeerPage> {
  const r = await apiClient().post<MyPeerPage>(
    `/my-giving/peer-pages/${pageId}/resume`,
  );
  return r.data;
}

export const mePeerPagesApi = {
  listMyPeerPages,
  pauseMyPeerPage,
  resumeMyPeerPage,
};
